import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@uhg-abyss/web/ui/Text';
import { event } from '@uhg-abyss/web/tools/event';
import { LinkFromHeaderContentLagoon } from './LinkFromHeaderContentLagoon';

export const RightRailSubCard = (props) => {
  const { railHeader, railLinks = [], toggleModal, user, widgetName } = props;

  const handleFileContextType = (link) => {
    const fileTypes = {
      chameleon: 'self paced chameleon guide',
      pdf: 'pdf guide',
      xlsx: 'xlsx',
    };

    const result = Object.keys(fileTypes).find((key) => link.includes(key));
    return fileTypes[result] || '';
  };

  const onClick = (railLink) => {
    const rightrailname = railLink?.name || railLink?.text;
    const rightraillink = railLink?.href || railLink?.link;
    // always trigger interaction event
    event('RIGHT_RAIL_LINK_CLICK', {
      widgetName,
      interactionName: railHeader,
      interactionValue: rightrailname,
    });
    if (railLink.isDownload) {
      event('DOWNLOAD_CLICK', {
        fileName: rightrailname,
        fileURL: rightraillink,
        fileType: handleFileContextType(rightraillink),
      });
    }
    if (!rightraillink.includes('#') && !railLink.isDownload) {
      event('EXIT_LINK_NAVIGATE', {
        linkText: rightrailname,
        linkUrl: rightraillink,
      });
    }
  };
  return (
    <React.Fragment>
      <Text
        color="$primary1"
        fontWeight="bold"
        size="20px"
        css={{ marginBottom: '15px' }}
      >
        {railHeader}
      </Text>
      <For index="index" each="railLink" of={railLinks}>
        <LinkFromHeaderContentLagoon
          key={`${index}-${railLink?.name}`}
          {...railLink}
          onClick={onClick}
          toggleModal={toggleModal}
          user={user}
        />
      </For>
    </React.Fragment>
  );
};

RightRailSubCard.propTypes = {
  railHeader: PropTypes.string.isRequired,
  railLinks: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      href: PropTypes.number.isRequired,
      useAPIRedirect: PropTypes.bool,
    })
  ).isRequired,
  toggleModal: PropTypes.func.isRequired,
  user: PropTypes.objectOf(PropTypes.any).isRequired,
  widgetName: PropTypes.string,
};

RightRailSubCard.defaultProps = {
  widgetName: undefined,
};
